var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-container"},[_vm._v("\n  错误,无当前路由\n  "),_c('router-link',{attrs:{"to":"/manage"}},[_vm._v("前往活动页")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/vue-loader@13.7.3_5456a318c21f0d6ee57754f126b5f593/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b759a80","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.pnpm/vue-loader@13.7.3_5456a318c21f0d6ee57754f126b5f593/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/error.vue
// module id = Rhtg
// module chunks = 2